module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "content resetpwd"
  }, [_c('div', {
    staticClass: "title font-size24 color-msg"
  }, [_vm._v("安全验证")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.inputType === _vm.CONF.inputType.mobile),
      expression: "this.inputType === CONF.inputType.mobile"
    }],
    staticClass: "font-size14 color-msg cue"
  }, [_vm._v("请使用手机"), _c('span', [_vm._v(_vm._s(_vm.account))]), _vm._v("获取验证码")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.inputType === _vm.CONF.inputType.mobileOrEmail),
      expression: "this.inputType === CONF.inputType.mobileOrEmail"
    }],
    staticClass: "font-size14 color-msg cue"
  }, [_vm._v("请使用邮箱"), _c('span', [_vm._v(_vm._s(_vm.account))]), _vm._v("获取验证码")]), _vm._v(" "), _c('div', {
    staticClass: "ipt-box font-size14"
  }, [_c('img-code', {
    attrs: {
      "imgCodeErrData": _vm.imgCodeErrData,
      "options": _vm.imgCodeData
    },
    on: {
      "imgCodeSuccess": _vm.imgCodeSuccess
    }
  }), _vm._v(" "), _c('mobile-code', {
    attrs: {
      "mobileCodeBtnState": _vm.mobileCodeBtnState,
      "inputType": _vm.CONF.inputType.mobileOrEmail,
      "imgCode": _vm.imgCode,
      "codeErrData": _vm.codeErrData
    },
    on: {
      "mobileCodeSuccess": _vm.mobileCodeSuccess,
      "mobileCodeSendFail": _vm.mobileCodeSendFail
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.enable),
      expression: " submitBtnState==CONF.submitBtnState.enable"
    }],
    staticClass: "account-btn",
    on: {
      "click": _vm.verificationCode
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.disable),
      expression: " submitBtnState==CONF.submitBtnState.disable"
    }],
    staticClass: "account-btn disable"
  }, [_vm._v("确 定")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-991d171c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/ResetGetCode.vue
// module id = 138
// module chunks = 1